var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",on:{"mouseenter":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[(_vm.isVisible)?_c('div',{staticClass:"tooltip-container-bottom"},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }